import type { Mark } from '../document-types';
import type { MarkHandler } from './types';

export class UnderlineMark implements MarkHandler {
  readonly type = 'underline';

  apply(text: string, _mark: Mark): string {
    // Markdown doesn't have native underline, use HTML
    return `<u>${text}</u>`;
  }
}
